@if (entity) {
  <article (click)="openTemplateList()" id="{{ renderMode }}" class="awesomedoc-section" [ngClass]="templatesListOpen ? 'awesomedoc-section-open' : 'awesomedoc-section-closed'"
    [matTooltip]="'Create an AwesomeDoc (Alt+Shift+A)'" [matTooltipDisabled]="templatesListOpen"
    matTooltipShowDelay="500" matTooltipPosition="below">
    <mat-icon fontIcon="expand_less" class="expand-section-icon" (click)="closeTemplateList($event)"
      [matTooltip]="templatesListOpen ? 'Close list of AwesomeDocs' : 'View list of AwesomeDocs'" matTooltipShowDelay="500" role="button"
      tabindex="0" (keydown.enter)="closeTemplateList($event)" (keydown.space)="closeTemplateList($event)">
    </mat-icon>
    <!--// Button-->
    <section id="awesomedoc-section-button" (click)="closeTemplateList($event)" (keydown.enter)="openTemplateList()"
      (keydown.space)="openTemplateList()" tabindex="0">
      <h3 class="box-title-bar heading-underline">
        <span class="box-title-text with-tip">
          <mat-icon fontSet="material-icons-outlined">widgets</mat-icon>
          <span>
            <span class="small-title-text">Create an </span>
            <span class="main-title-text">AwesomeDoc</span>
          </span>
          @if (!templatesListOpen) {
            <span class="small info-tip">
              <mat-icon fontSet="material-icons-outlined">info</mat-icon> Existing templates for {{ entityLabel | titlecase }} records
            </span>
          }
          <mat-icon class="big-watermark-icon" fontSet="material-icons-outlined">widgets</mat-icon>
          @if (templatesListOpen && renderMode === 'web-app') {
            <span class="header-search-and-refresh">
              <span class="header-search-input-wrapper">
                <input #searchInputEl class="header-search-input" type="text" placeholder="Search (Ctrl+Shift+S)..."
                       (input)="onSearchInput($event)" (click)="$event.stopPropagation()"
                       (keydown.space)="$event.stopPropagation()" (keydown.escape)="clearSearch()" />
                <mat-icon class="header-search-icon" [fontIcon]="searchInputEl.value ? 'close' : 'search'"
                          (click)="clearSearch(); $event.stopPropagation()"></mat-icon>
              </span>
              <span class="sync-icon-hit-area" (click)="refresh($event)">
                <mat-icon class="sync-icon" fontIcon="autorenew" role="button" tabindex="0"
                          [matTooltip]="'Refresh'" matTooltipShowDelay="500"
                          (keydown.enter)="refresh($event)"
                          (keydown.space)="$event.preventDefault(); refresh($event)">
                </mat-icon>
              </span>
            </span>
          }
        </span>
      </h3>
    </section>
    <!--// AwesomeDoc list-->
    @if (templatesListOpen) {
      <section id="awesomedoc-list">
        <div class="box-files-container">
          @if (renderMode === 'chrome-extension' && entity) {
            <h3 class="box-title-bar heading-underline">
              <span class="box-title-text">
                @if (!showSpinner) {
                  <mat-icon fontSet="material-icons-outlined">widgets</mat-icon>
                  @if (entity) {
                    <span>AwesomeDocs</span>
                  }
                  <!-- TODO: always show refresh? -->
                  @if (entity) {
                    <span class="header-search-and-refresh">
                      <span class="header-search-input-wrapper">
                        <input #searchInputEl class="header-search-input" type="text" placeholder="Search (Ctrl+Shift+H)..."
                          (input)="onSearchInput($event)" (click)="$event.stopPropagation()"
                          (keydown.space)="$event.stopPropagation()" (keydown.escape)="clearSearch()" />
                        <mat-icon class="header-search-icon" [fontIcon]="searchInputEl.value ? 'close' : 'search'"
                          (click)="clearSearch(); $event.stopPropagation()"></mat-icon>
                      </span>
                      <mat-icon
                        class="sync-icon"
                        fontIcon="autorenew"
                        (click)="refresh($event)"
                        [matTooltip]="'Refresh AwesomeDocs'"
                        matTooltipShowDelay="500"
                        role="button"
                        tabindex="0"
                        (keydown.enter)="refresh($event)"
                      ></mat-icon>
                    </span>
                  }
                }
              </span>
            </h3>
          }
          @if (entity && !showSpinner && templateRows.length === 0) {
            <div class="box-no-files-text placeholder-text">
              NO TEMPLATES AVAILABLE FOR THIS ENTITY
            </div>
          }
          <app-kp-simple-table
            [items]="templateRows"
            [isLoading]="showSpinner"
            [tableClasses]="'first-col-icon'"
            [skeletonRowClasses]="'big-row'"
            [skeletonRowInstances]="3"
            [columnHeadings]="columnHeadings"
            [searchFn]="templateSearchFn"
            (actionClick)="itemActionClick($event)">
          </app-kp-simple-table>
        </div>
      </section>
    }
    <section id="tip">
      <mat-icon fontSet="material-icons-outlined">info</mat-icon>
      <span>Create documents from existing AwesomeDoc templates</span>
    </section>
  </article>
}
